/*
  HAPPE BOX V3 - Intersection Observer Lazy Loader (theme-observer.js)
*/

class HappeIntersectionObserver {
  constructor() {
    this.observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.triggerLoad(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '100px' });
  }

  observe(element, callback) {
    if (!element) return;
    element._happe_obs_cb = callback;
    this.observer.observe(element);
  }

  triggerLoad(element) {
    if (typeof element._happe_obs_cb === 'function') {
      element._happe_obs_cb(element);
    }
  }
}

window.HappeObserverClass = HappeIntersectionObserver;
